export default "__VITE_ASSET__lq33j0Sn__"